export const FULL_WIDTH_COMPONENTS = [
  'banner',
  'banner-slider',
  'mobile-icon-carousel',
  'countdown-teaser',
  'service-teaser-list',
  'footer'
];

export const GAP_LESS_COMPONENTS = ['anchor'];

export enum PageTemplate {
  ONE_COLUMN = 'one-column',
  ONE_COLUMN_FULL_WIDTH = 'one-column-full-width',
  TWO_COLUMN = 'two-column',
  STANDARD_PLP = 'standard-plp',
  AUGMENTED_PLP = 'augmented-plp',
  DECORATED_PDP = 'decorated-pdp',
  DECORATED_PLP = 'decorated-plp',
  SMART_CATEGORY_PLP = 'smart-category-plp'
}

export const SIDE_BY_SIDE_TEMPLATES = [
  PageTemplate.TWO_COLUMN,
  PageTemplate.STANDARD_PLP,
  PageTemplate.AUGMENTED_PLP,
  PageTemplate.DECORATED_PLP,
  PageTemplate.SMART_CATEGORY_PLP
];

export enum ImageMimeTypes {
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  WEBP = 'image/webp',
  SVG = 'image/svg+xml',
  GIF = 'image/gif',
  AVIF = 'image/avif'
}
